export default {
  prefixes() {
    return [
      {
        prefix: "+93",
        size: [9],
        code: "AF",
        name_EN: "Afghanistan",
        name_own: "افغانستان",
        localPrefixes: [
          7, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 31,
          32, 33, 34, 40, 41, 42, 43, 44, 50, 51, 52, 53,
          54, 55, 56, 57, 58, 60, 61, 62, 63, 64, 65,
        ],
        default: true,
      },
      {
        prefix: "+355",
        size: [8, 9],
        code: "AL",
        name_EN: "Albania",
        name_own: "Shqipëri",
        localPrefixes: [
          4, 6, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 51, 52, 53, 54,
          55, 56, 57, 58, 59, 81, 82, 83, 84, 85, 86, 87,
          88, 89,
        ],
        default: true,
      },
      {
        prefix: "+213",
        size: [8, 9],
        code: "DZ",
        name_EN: "Algeria",
        name_own: "الجزائر",
        localPrefixes: [
          2, 3, 40, 41, 43, 44, 46, 48, 49, 55, 540, 541,
          542, 549, 560, 561, 562, 563, 564, 6, 77, 78, 79,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "AS",
        name_EN: "American Samoa",
        localPrefixes: [684],
      },
      {
        prefix: "+376",
        size: [6],
        code: "AD",
        name_EN: "Andorra",
        localPrefixes: [3, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+244",
        size: [9],
        code: "AO",
        name_EN: "Angola",
        localPrefixes: [2, 9],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "AI",
        name_EN: "Anguilla",
        localPrefixes: [264],
      },
      {
        prefix: "+1",
        size: [10],
        code: "AG",
        name_EN: "Antigua and Barbuda",
        localPrefixes: [268],
      },
      {
        prefix: "+54",
        size: [10],
        code: "AR",
        name_EN: "Argentina",
        localPrefixes: [
          9, 249, 221, 2901, 2920, 353, 11, 291, 383, 297, 345, 379,
          370, 3525, 221, 380, 223, 263, 261, 2324, 220, 299, 343, 376,
          11, 3482, 362, 358, 2966, 341, 387, 294, 2252, 264, 266, 263,
          381, 336, 260, 388, 342, 2954, 385, 3756, 351,
        ],
        default: true,
      },
      {
        prefix: "+374",
        size: [8],
        code: "AM",
        name_EN: "Armenia",
        name_own: "Հայաստան",
        localPrefixes: [
          10, 11, 12, 15, 33, 41, 43, 44, 47, 49, 55, 77,
          88, 91, 93, 94, 95, 96, 97, 98, 99, 222, 223, 224,
          226, 231, 232, 233, 234, 235, 236, 237, 238, 242, 243, 244,
          245, 246, 249, 252, 253, 254, 255, 256, 257, 261, 262, 263,
          264, 265, 266, 267, 268, 269, 281, 282, 283, 284, 285, 286,
          287, 312, 322,
        ],
        default: true,
      },
      {
        prefix: "+297",
        size: [7],
        code: "AW",
        name_EN: "Aruba",
        localPrefixes: [2, 5, 6, 7, 9],
        default: true,
      },
      {
        prefix: "+61",
        size: [7, 9, 10],
        code: "AU",
        name_EN: "Australia",
        localPrefixes: [4, 2, 8, 3, 7, 8, 13, 18],
        default: true,
      },
      {
        prefix: "+43",
        size: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        code: "AT",
        name_EN: "Austria",
        name_own: "Österreich",
        localPrefixes: [
          1, 6, 650, 651, 652, 653, 655, 657, 659, 660, 661, 663,
          664, 665, 666, 667, 668, 669, 67, 68, 69, 6485, 214, 216,
          217, 221, 223, 224, 225, 226, 227, 228, 252, 253, 255, 257,
          261, 262, 263, 264, 266, 267, 268, 271, 272, 273, 274, 275,
          276, 277, 278, 281, 282, 284, 285, 286, 287, 291, 294, 295,
          298, 311, 312, 313, 315, 317, 318, 332, 333, 335, 336, 338,
          345, 346, 347, 351, 353, 357, 358, 361, 362, 363, 368, 383,
          384, 385, 386, 388, 316, 421, 422, 423, 424, 425, 426, 427,
          428, 435, 463, 471, 473, 476, 478, 482, 484, 485, 487, 512,
          521, 522, 523, 524, 525, 526, 527, 528, 533, 535, 537, 541,
          544, 547, 551, 552, 555, 557, 558, 563, 567, 613, 621, 622,
          623, 624, 627, 641, 643, 645, 646, 647, 654, 656, 658, 662,
          721, 722, 723, 724, 725, 726, 727, 728, 732, 735, 741, 743,
          744, 747, 748, 756, 758, 761, 766, 767, 768, 771, 772, 773,
          774, 775, 776, 794, 795,
        ],
        default: true,
      },
      {
        prefix: "+994",
        size: [9],
        code: "AZ",
        name_EN: "Azerbaijan",
        name_own: "Azərbaycan",
        localPrefixes: [
          347, 40, 44, 50, 51, 55, 60, 70, 77, 12, 26, 20,
          22, 25, 24, 36, 21, 18, 23, 46, 10, 99,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "BS",
        name_EN: "Bahamas",
        localPrefixes: [242],
      },
      {
        prefix: "+973",
        size: [8],
        code: "BH",
        name_EN: "Bahrain",
        name_own: "البحرين",
        localPrefixes: [1, 3, 6, 7],
        default: true,
      },
      {
        prefix: "+880",
        size: [4, 5, 6, 7, 8, 9, 10, 11],
        code: "BD",
        name_EN: "Bangladesh",
        name_own: "বাংলাদেশ",
        localPrefixes: [
          1, 2, 431, 51, 851, 31, 81, 341, 531, 681, 421, 41,
          488, 691, 91, 628, 6225, 321, 731, 721, 521, 552, 821, 921,
          37, 38, 44, 66,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "BB",
        name_EN: "Barbados",
        localPrefixes: [246],
      },
      {
        prefix: "+375",
        size: [7, 8, 9, 10, 11],
        code: "BY",
        name_EN: "Belarus",
        name_own: "Беларусь",
        localPrefixes: [
          25, 29, 33, 44, 17, 225, 163, 177, 16, 23, 15, 236, 22, 176, 216, 165,
          214, 174, 21,
        ],
        default: true,
      },
      {
        prefix: "+32",
        size: [7, 8, 9],
        code: "BE",
        name_EN: "Belgium",
        name_own: "België",
        localPrefixes: [
          2, 3, 4, 5, 9, 71, 10, 11, 12, 13, 14, 16,
          19, 60, 61, 63, 64, 65, 67, 68, 69, 81, 82, 83,
          84, 85, 87, 89,
        ],
        default: true,
      },
      {
        prefix: "+501",
        size: [7],
        code: "BZ",
        name_EN: "Belize",
        localPrefixes: [6, 8, 2, 4, 5, 3, 7],
        default: true,
      },
      {
        prefix: "+229",
        size: [10],
        code: "BJ",
        name_EN: "Benin",
        name_own: "Bénin",
        localPrefixes: ["01"],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "BM",
        name_EN: "Bermuda",
        localPrefixes: [441],
      },
      {
        prefix: "+975",
        size: [7, 8],
        code: "BT",
        name_EN: "Bhutan",
        name_own: "Druk Yul",
        localPrefixes: [17, 2, 3, 4, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+591",
        size: [8],
        code: "BO",
        name_EN: "Bolivia",
        localPrefixes: [2, 3, 4, 6, 7],
        default: true,
      },
      {
        prefix: "+387",
        size: [8],
        code: "BA",
        name_EN: "Bosnia And Herzegovina",
        name_own: "Bosna i Hercegovina",
        localPrefixes: [
          6, 30, 31, 32, 33, 34, 35, 36, 37, 38, 49, 51,
          52, 53, 54, 55, 56, 57, 58, 59,
        ],
        default: true,
      },
      {
        prefix: "+267",
        size: [7, 8],
        code: "BW",
        name_EN: "Botswana",
        localPrefixes: [
          7, 3, 2, 54, 47, 68, 59, 26, 46, 53, 57, 58, 6,
        ],
        default: true,
      },
      {
        prefix: "+55",
        size: [8, 10, 11],
        code: "BR",
        name_EN: "Brazil",
        name_own: "Brasil",
        localPrefixes: [
          436, 437, 438, 439, 966, 967, 968, 969, 826, 827, 828, 829, 926, 927, 928, 929,
          616, 617, 618, 619, 916, 917, 918, 919, 796, 797, 798, 799, 146, 147, 148, 149,
          316, 317, 318, 319, 956, 957, 958, 959, 676, 677, 678, 679, 516, 517, 518, 519,
          116, 117, 118, 119, 276, 277, 278, 279, 546, 547, 548, 549, 656, 657, 658, 659,
          416, 417, 418, 419, 216, 217, 218, 219, 976, 977, 978, 979, 756, 757, 758, 759,
          486, 487, 488, 489, 856, 857, 858, 859, 166, 167, 168, 169, 626, 627, 628, 629,
          836, 837, 838, 839, 476, 477, 478, 479, 326, 327, 328, 329, 446, 447, 448, 449,
          386, 387, 388, 389, 846, 847, 848, 849, 816, 817, 818, 819, 636, 637, 638, 639,
          246, 247, 248, 249, 196, 197, 198, 199, 696, 697, 698, 699, 186, 187, 188, 189,
          686, 687, 688, 689, 716, 717, 718, 719, 986, 987, 988, 989, 136, 137, 138, 139,
          176, 177, 178, 179, 126, 127, 128, 129, 156, 157, 158, 159, 866, 867, 868, 869,
          346, 347, 348, 349, 226, 227, 228, 229, 286, 287, 288, 289, 336, 337, 338, 339,
          356, 357, 358, 359, 376, 377, 378, 379, 426, 427, 428, 429, 456, 457, 458, 459,
          536, 537, 538, 539, 556, 557, 558, 559, 646, 647, 648, 649, 666, 667, 668, 669,
          736, 737, 738, 739, 746, 747, 748, 749, 776, 777, 778, 779, 876, 877, 878, 879,
          886, 887, 888, 889, 896, 897, 898, 899, 936, 937, 938, 939, 946, 947, 948, 949,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "VG",
        name_EN: "British Virgin Islands",
        localPrefixes: [284],
      },
      {
        prefix: "+673",
        size: [7],
        code: "BN",
        name_EN: "Brunei",
        localPrefixes: [8, 2, 3, 5, 4, 7],
        default: true,
      },
      {
        prefix: "+359",
        size: [7, 8, 9],
        code: "BG",
        name_EN: "Bulgaria",
        name_own: "България",
        localPrefixes: [
          2, 3, 4, 5, 6, 7, 8, 9, 87, 56, 73, 58,
          66, 751, 38, 361, 431, 78, 68, 96, 34, 76, 64, 32,
          84, 82, 54, 86, 44, 301, 42, 601, 52, 62, 94, 92,
          46,
        ],
        default: true,
      },
      {
        prefix: "+226",
        size: [8],
        code: "BF",
        name_EN: "Burkina Faso",
        localPrefixes: [7, 6, 50, 20, 40, 24, 25, 4, 5],
        default: true,
      },
      {
        prefix: "+257",
        size: [8],
        code: "BI",
        name_EN: "Burundi",
        localPrefixes: [22, 7, 31, 29, 6],
        default: true,
      },
      {
        prefix: "+855",
        size: [8, 9],
        code: "KH",
        name_EN: "Cambodia",
        localPrefixes: [
          1, 6, 7, 8, 9, 23, 24, 25, 26, 31, 32, 33,
          34, 35, 36, 38, 42, 43, 44, 52, 53, 54, 55, 62,
          63, 64, 65, 72, 73, 74, 75,
        ],
        default: true,
      },
      {
        prefix: "+237",
        size: [9],
        code: "CM",
        name_EN: "Cameroon",
        name_own: "Cameroun",
        localPrefixes: [6, 222, 233, 242, 243],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "CA",
        name_EN: "Canada",
        localPrefixes: [
          613, 343, 403, 587, 825, 902, 418, 581, 780, 506, 819, 873,
          905, 289, 365, 519, 226, 548, 450, 579, 514, 438, 306, 639,
          709, 807, 416, 647, 437, 604, 778, 236, 250, 867, 204, 431,
          249, 257, 263, 354, 367, 368, 672, 705, 742, 753, 782,
        ],
      },
      {
        prefix: "+238",
        size: [7],
        code: "CV",
        name_EN: "Cape Verde",
        name_own: "Cabo Verde",
        localPrefixes: [2, 9, 36, 5],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "KY",
        name_EN: "Cayman Islands",
        localPrefixes: [345],
      },
      {
        prefix: "+236",
        size: [8],
        code: "CF",
        name_EN: "Central African Republic",
        name_own: "République centrafricaine",
        localPrefixes: [21, 22, 61, 70, 72, 73, 74, 75, 76, 77],
        default: true,
      },
      {
        prefix: "+235",
        size: [8],
        code: "TD",
        name_EN: "Chad",
        name_own: "Tchad",
        localPrefixes: [22, 6, 9, 30, 31, 77, 85, 86, 87],
        default: true,
      },
      {
        prefix: "+56",
        size: [8, 9],
        code: "CL",
        name_EN: "Chile",
        localPrefixes: [
          9, 2, 57, 55, 58, 41, 42, 52, 51, 67, 75, 32, 73, 34, 43, 64, 53, 65,
          61, 33, 32, 72, 35, 71, 45, 63,
        ],
        default: true,
      },
      {
        prefix: "+86",
        size: [8, 9, 10, 11],
        code: "CN",
        name_EN: "China",
        name_own: "中國",
        localPrefixes: [
          13, 145, 147, 150, 151, 152, 153, 155, 156, 157, 158, 159, 1610,
          162, 165, 166, 167, 170, 171, 172, 173, 174, 175, 176, 177, 178, 18,
          190, 191, 192, 193, 195, 196, 197, 198, 199, 10, 431, 731, 28, 23,
          411, 769, 757, 591, 20, 851, 571, 451, 551, 752, 871, 931, 578, 379,
          791, 25, 574, 532, 595, 21, 754, 24, 755, 311, 557, 512, 351, 315,
          22, 991, 577, 27, 510, 29, 516, 535, 371, 533,
        ],
        default: true,
      },
      {
        prefix: "+57",
        size: [8, 10],
        code: "CO ",
        name_EN: "Colombia",
        localPrefixes: [3, 1, 4, 7, 6, 5, 2, 8],
        default: true,
      },
      {
        prefix: "+269",
        size: [7],
        code: "KM",
        name_EN: "Comoros",
        name_own: "جزر القمر",
        localPrefixes: [3, 4, 7],
        default: true,
      },
      {
        prefix: "+682",
        size: [5],
        code: "CK",
        name_EN: "Cook Islands",
        localPrefixes: [5, 2, 31, 33, 34, 43, 35, 36, 45, 37, 42, 41, 44, 7, 8],
        default: true,
      },
      {
        prefix: "+506",
        size: [8],
        code: "CR",
        name_EN: "Costa Rica",
        localPrefixes: [2, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+385",
        size: [8, 9],
        code: "HR",
        name_EN: "Croatia",
        name_own: "Hrvatska",
        localPrefixes: [
          9, 1, 43, 40, 20, 53, 47, 48, 49, 31, 52, 34, 51, 22, 44, 35, 21, 42,
          32, 33, 23,
        ],
        default: true,
      },
      {
        prefix: "+53",
        size: [6, 7, 8],
        code: "CU",
        name_EN: "Cuba",
        localPrefixes: [
          5, 7, 47, 99, 23, 32, 45, 33, 43, 22, 21,
          24, 31, 46, 48, 49, 41, 42, 62, 63, 64,
        ],
        default: true,
      },
      {
        prefix: "+599",
        size: [7, 8],
        code: "CW",
        name_EN: "Curacao",
        localPrefixes: [9],
        default: true,
      },
      {
        prefix: "+357",
        size: [8],
        code: "CY",
        name_EN: "Cyprus",
        name_own: "Κύπρος",
        localPrefixes: [9, 22, 23, 24, 25, 26],
        default: true,
      },
      {
        prefix: "+420",
        size: [8, 9, 10],
        code: "CZ",
        name_EN: "Czech Republic",
        name_own: "Česká republika",
        localPrefixes: [
          6, 7, 2, 51, 53, 54, 38, 39, 49, 56, 35, 48, 58, 55, 59, 46, 37, 31,
          32, 41, 47, 57,
        ],
        default: true,
      },
      {
        prefix: "+243",
        size: [7, 9],
        code: "CD",
        name_EN: "Democratic Republic of the Congo",
        name_own: "République Démocratique du Congo",
        localPrefixes: [8, 9, 1, 3, 6, 5, 4, 2],
        default: true,
      },
      {
        prefix: "+45",
        size: [8],
        code: "DK",
        name_EN: "Denmark",
        name_own: "Danmark",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+253",
        size: [8],
        code: "DJ",
        name_EN: "Djibouti",
        localPrefixes: [21, 27, 77],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "DM",
        name_EN: "Dominica",
        localPrefixes: [767],
      },
      {
        prefix: "+1",
        size: [7, 10],
        code: "DO",
        name_EN: "Dominican Republic",
        name_own: "República Dominicana",
        localPrefixes: [809, 829, 849],
      },
      {
        prefix: "+670",
        size: [7, 8],
        code: "TL",
        name_EN: "East Timor",
        name_own: "Timor Leste",
        localPrefixes: [2, 3, 4, 7],
        default: true,
      },
      {
        prefix: "+593",
        size: [8, 9],
        code: "EC",
        name_EN: "Ecuador",
        localPrefixes: [9, 2, 3, 7, 5, 4, 6],
        default: true,
      },
      {
        prefix: "+20",
        size: [8, 9, 10],
        code: "EG",
        name_EN: "Egypt",
        name_own: "مصر",
        localPrefixes: [
          1, 2, 3, 88, 97, 13, 82, 45, 57, 68, 92, 50, 69, 84, 65, 64, 47, 95,
          46, 86, 66, 96, 48, 62, 93, 40, 55,
        ],
        default: true,
      },
      {
        prefix: "+503",
        size: [8],
        code: "SV",
        name_EN: "El Salvador",
        localPrefixes: [2, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+240",
        size: [9],
        code: "GQ",
        name_EN: "Equatorial Guinea",
        name_own: "Guinea Ecuatorial",
        localPrefixes: [3, 222, 55],
        default: true,
      },
      {
        prefix: "+291",
        size: [7],
        code: "ER",
        name_EN: "Eritrea",
        localPrefixes: [1, 7, 17, 8],
        default: true,
      },
      {
        prefix: "+372",
        size: [7, 8],
        code: "EE",
        name_EN: "Estonia",
        name_own: "Eesti",
        localPrefixes: [3, 4, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+251",
        size: [9],
        code: "ET",
        name_EN: "Ethiopia",
        name_own: "ኢትዮጵያ",
        localPrefixes: [9, 11, 22, 57, 46, 58, 33, 25, 47, 34, 7],
        default: true,
      },
      {
        prefix: "+500",
        size: [5],
        code: "FK",
        name_EN: "Falkland Islands",
        localPrefixes: [2, 3, 4, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+298",
        size: [6],
        code: "FO",
        name_EN: "Faroe Islands",
        name_own: "Færøerne",
        localPrefixes: [2, 3, 4, 5, 7, 81, 89, 91, 96],
        default: true,
      },
      {
        prefix: "+679",
        size: [7, 9],
        code: "FJ",
        name_EN: "Fiji",
        localPrefixes: [2, 3, 45, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+358",
        size: [8, 9],
        code: "FI",
        name_EN: "Finland",
        name_own: "Suomi",
        localPrefixes: [4, 50, 9, 3, 14, 17, 5, 16, 18, 15, 8, 13, 2, 19, 6],
        default: true,
      },
      {
        prefix: "+33",
        size: [9],
        code: "FR",
        name_EN: "France",
        localPrefixes: [6, 7, 1, 4, 3, 2, 5, 495],
        default: true,
      },
      {
        prefix: "+689",
        size: [6],
        code: "PF",
        name_EN: "French Polynesia",
        name_own: "Polynésie française",
        localPrefixes: [2, 3, 4, 7, 8],
        default: true,
      },
      {
        prefix: "+241",
        size: [7],
        code: "GA",
        name_EN: "Gabon",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+220",
        size: [7],
        code: "GM",
        name_EN: "Gambia",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+995",
        size: [8, 9, 10],
        code: "GE",
        name_EN: "Georgia",
        name_own: "საქართველო",
        localPrefixes: [5, 7, 32, 34, 35, 36, 37, 41, 42, 43, 44, 47, 49],
        default: true,
      },
      {
        prefix: "+49",
        size: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        code: "DE",
        name_EN: "Germany",
        name_own: "Deutschland",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+233",
        size: [9],
        code: "GH",
        name_EN: "Ghana",
        localPrefixes: [2, 5, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
        default: true,
      },
      {
        prefix: "+350",
        size: [8],
        code: "GI",
        name_EN: "Gibraltar",
        localPrefixes: [2, 5],
        default: true,
      },
      {
        prefix: "+30",
        size: [8, 9, 10, 11, 12],
        code: "GR",
        name_EN: "Greece",
        name_own: "Ελλάδα",
        localPrefixes: [2, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+299",
        size: [6],
        code: "GL",
        name_EN: "Greenland",
        name_own: "Grænland",
        localPrefixes: [2, 4, 5, 19, 3, 6, 70, 8, 9],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "GD",
        name_EN: "Grenada",
        localPrefixes: [473],
      },
      {
        prefix: "+1",
        size: [10],
        code: "GU",
        name_EN: "Guam",
        localPrefixes: [671],
      },
      {
        prefix: "+502",
        size: [8],
        code: "GT",
        name_EN: "Guatemala",
        localPrefixes: [2, 3, 4, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+224",
        size: [8],
        code: "GN",
        name_EN: "Guinea",
        name_own: "Guinée",
        localPrefixes: [30, 31, 6],
        default: true,
      },
      {
        prefix: "+245",
        size: [7],
        code: "GW",
        name_EN: "Guinea-Bissau",
        name_own: "Guiné-Bissau",
        localPrefixes: [4, 9],
        default: true,
      },
      {
        prefix: "+592",
        size: [7],
        code: "GY",
        name_EN: "Guyana",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+509",
        size: [8],
        code: "HT",
        name_EN: "Haiti",
        name_own: "Ayiti",
        localPrefixes: [2, 3, 4, 5, 8, 9],
        default: true,
      },
      {
        prefix: "+504",
        size: [8],
        code: "HN",
        name_EN: "Honduras",
        localPrefixes: [3, 7, 8, 9, 22, 28, 26, 27, 24, 25],
        default: true,
      },
      {
        prefix: "+852",
        size: [8],
        code: "HK",
        name_EN: "Hong Kong",
        name_own: "香港",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+36",
        size: [7, 8, 9],
        code: "HU",
        name_EN: "Hungary",
        name_own: "Magyarország",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+354",
        size: [7],
        code: "IS",
        name_EN: "Iceland",
        name_own: "Ísland",
        localPrefixes: [3, 6, 7, 8, 5, 4],
        default: true,
      },
      {
        prefix: "+91",
        size: [8, 9, 10, 11, 12],
        code: "IN",
        name_EN: "India",
        name_own: "भारत",
        localPrefixes: [
          9, 11, 381, 562, 79, 389, 571, 532, 183, 341, 240, 80, 2522, 757, 674,
          22, 33, 172, 44, 422, 671, 135, 3862, 129, 79, 3592, 120, 361, 751,
          33, 836, 40, 3852, 731, 761, 141, 181, 657, 291, 512, 522, 161, 121,
          821, 712, 253, 832, 612, 20, 3192, 771, 281, 651, 427, 177, 217, 194,
          261, 471, 431, 265, 542, 866, 891, 7152, 6, 7, 8,
        ],
        default: true,
      },
      {
        prefix: "+62",
        size: [7, 8, 9, 10, 11],
        code: "ID",
        name_EN: "Indonesia",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+98",
        size: [9, 10, 11],
        code: "IR",
        name_EN: "Iran",
        name_own: "ایران",
        localPrefixes: [
          9, 11, 13, 17, 21, 23, 24, 25, 26, 28, 31, 34, 35, 38, 41, 44, 45,
          51, 54, 56, 58, 61, 66, 71, 74, 76, 77, 81, 83, 84, 86, 87,
        ],
        default: true,
      },
      {
        prefix: "+964",
        size: [7, 8, 9, 10],
        code: "IQ",
        name_EN: "Iraq",
        localPrefixes: [
          7, 1, 43, 30, 37, 25, 40, 36, 62, 66, 32, 50, 23, 60, 42, 33, 24, 53,
          21,
        ],
        default: true,
      },
      {
        prefix: "+353",
        size: [8, 9, 10],
        code: "IE",
        name_EN: "Ireland",
        name_own: "Éireann",
        localPrefixes: [1, 2, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+972",
        size: [8, 9],
        code: "IL",
        name_EN: "Israel",
        name_own: "ישראל",
        localPrefixes: [2, 3, 4, 5, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+39",
        size: [8, 9, 10, 11, 12],
        code: "IT",
        name_EN: "Italy",
        name_own: "Italia",
        localPrefixes: ["3", "0"],
        default: true,
      },
      {
        prefix: "+225",
        size: [8],
        code: "CI",
        name_EN: "Ivory Coast",
        name_own: "Côte d'Ivoire",
        localPrefixes: [0, 2],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "JM",
        name_EN: "Jamaica",
        localPrefixes: [658, 876],
      },
      {
        prefix: "+81",
        size: [5, 6, 7, 8, 9, 10, 11, 12, 13],
        code: "JP",
        name_EN: "Japan",
        name_own: "日本",
        localPrefixes: [
          70, 80, 90, 3, 18, 6, 17, 166, 43, 466, 92, 84, 47, 58, 42, 53, 6, 79,
          72, 82, 586, 246, 99, 76, 4, 49, 48, 44, 75, 93, 78, 88, 24, 48, 96,
          86, 942, 42, 27, 89, 985, 19, 26, 95, 52, 98, 742, 25, 798, 97, 86,
          564, 77, 42, 11, 22, 54, 87, 532, 565, 59, 28, 73, 45, 46, 55, 29,
          23, 83, 852, 857,
        ],
        default: true,
      },
      {
        prefix: "+962",
        size: [8, 9],
        code: "JO",
        name_EN: "Jordan",
        name_own: "الأردن",
        localPrefixes: [7, 6, 2, 3, 5, 4, 8],
        default: true,
      },
      {
        prefix: "+7",
        size: [10],
        code: "KZ",
        name_EN: "Kazakhstan",
        name_own: "Қазақстан",
        localPrefixes: [7],
      },
      {
        prefix: "+254",
        size: [7, 8, 9],
        code: "KE",
        name_EN: "Kenya",
        localPrefixes: [1, 2, 4, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+686",
        size: [5],
        code: "KI",
        name_EN: "Kiribati",
        localPrefixes: [2, 3, 4, 50, 6, 8, 9],
        default: true,
      },
      {
        prefix: "+383",
        size: [8],
        code: "XK",
        name_EN: "Kosovo",
        name_own: "Kosovë",
        localPrefixes: [28, 29, 38, 39, 4],
        default: true,
      },
      {
        prefix: "+965",
        size: [8],
        code: "KW",
        name_EN: "Kuwait",
        name_own: "الكويت",
        localPrefixes: [2, 6, 9, 5, 4],
        default: true,
      },
      {
        prefix: "+996",
        size: [8, 9, 10],
        code: "KG",
        name_EN: "Kyrgyzstan",
        name_own: "Кыргызстан",
        localPrefixes: [2, 3, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+856",
        size: [8, 10],
        code: "LA",
        name_EN: "Laos",
        name_own: "ກຸຍກີສະຕາລ້າ",
        localPrefixes: [
          20, 21, 71, 31, 54, 34, 41, 51, 64, 23, 30, 61, 74, 81, 84, 86, 88,
        ],
        default: true,
      },
      {
        prefix: "+371",
        size: [7, 8, 9],
        code: "LV",
        name_EN: "Latvia",
        name_own: "Latvija",
        localPrefixes: [2, 6],
        default: true,
      },
      {
        prefix: "+961",
        size: [7, 8],
        code: "LB",
        name_EN: "Lebanon",
        name_own: "لبنان",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+266",
        size: [8],
        code: "LS",
        name_EN: "Lesotho",
        localPrefixes: [2, 5, 6],
        default: true,
      },
      {
        prefix: "+231",
        size: [7, 8],
        code: "LR",
        name_EN: "Liberia",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+218",
        size: [7, 8, 9, 10],
        code: "LY",
        name_EN: "Libya",
        name_own: "ليبيا",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+423",
        size: [7],
        code: "LI",
        name_EN: "Liechtenstein",
        localPrefixes: [2, 3, 6, 7],
        default: true,
      },
      {
        prefix: "+370",
        size: [8],
        code: "LT",
        name_EN: "Lituania",
        localPrefixes: [6, 31, 34, 37, 38, 41, 42, 44, 45, 46, 52],
        default: true,
      },
      {
        prefix: "+352",
        size: [6, 7, 8, 9, 10, 11, 12],
        code: "LU",
        name_EN: "Luxembourg",
        name_own: "Lëtzebuerg",
        localPrefixes: [
          6, 2422, 22, 2428, 2622, 2627, 2628, 2722, 2728, 28, 4, 80, 2480,
          2680, 2780, 58, 2458, 2658, 2758, 51, 2451, 2452, 52, 2467, 2651,
          2652, 2667, 2751, 2752, 2767, 53, 54, 55, 57, 2453, 2454, 2455, 2457,
          2653, 2654, 2655, 265, 32, 2432, 2632, 2732, 50, 2650, 2365, 2665,
          2776, 30, 31, 33, 34, 36, 37, 38, 39, 56, 59, 7,
        ],
        default: true,
      },
      {
        prefix: "+853",
        size: [8],
        code: "MO",
        name_EN: "Macau",
        name_own: "澳門",
        localPrefixes: [6, 28, 8],
        default: true,
      },
      {
        prefix: "+389",
        size: [7, 8, 9],
        code: "MK",
        name_EN: "Macedonia",
        name_own: "Македонија",
        localPrefixes: [7, 2, 47, 42, 43, 33, 31, 46, 48, 32, 34, 44, 45],
        default: true,
      },
      {
        prefix: "+261",
        size: [7, 9],
        code: "MG",
        name_EN: "Madagascar",
        name_own: "Madagasikara",
        localPrefixes: [
          3, 202, 2054, 204, 2044, 2082, 2073, 2075, 2062, 2072, 2053, 2092,
          2094, 2047, 2056, 2057, 2067, 2069, 2076, 2086, 2088, 2095, 2097,
        ],
        default: true,
      },
      {
        prefix: "+265",
        size: [7, 8, 9],
        code: "MW",
        name_EN: "Malawi",
        localPrefixes: [1, 77, 21, 22, 31, 88, 89, 98, 99],
        default: true,
      },
      {
        prefix: "+60",
        size: [7, 8, 9, 10],
        code: "MY",
        name_EN: "Malaysia",
        localPrefixes: [1, 3, 5, 7, 9, 88, 82, 89, 6, 4, 83, 84, 85, 86, 87],
        default: true,
      },
      {
        prefix: "+960",
        size: [7],
        code: "MV",
        name_EN: "Maldives",
        name_own: "মালদ্বীপ",
        localPrefixes: [7, 9, 3, 6],
        default: true,
      },
      {
        prefix: "+223",
        size: [8],
        code: "ML",
        name_EN: "Mali",
        localPrefixes: [
          6, 7, 20, 44, 218, 212, 215, 214, 213, 216, 219, 217, 5, 8, 9,
        ],
        default: true,
      },
      {
        prefix: "+356",
        size: [8],
        code: "MT",
        name_EN: "Malta",
        localPrefixes: [79, 99, 2, 7, 9],
        default: true,
      },
      {
        prefix: "+692",
        size: [7],
        code: "MH",
        name_EN: "Marshall Islands",
        localPrefixes: [2, 3, 4, 5, 6],
        default: true,
      },
      {
        prefix: "+222",
        size: [8],
        code: "MR",
        name_EN: "Mauritania",
        name_own: "موريتانيا",
        localPrefixes: [2, 3, 4],
        default: true,
      },
      {
        prefix: "+230",
        size: [7, 8],
        code: "MU",
        name_EN: "Mauritius",
        localPrefixes: [2, 4, 5, 6, 7, 8],
        default: true,
      },
      {
        prefix: "+262",
        size: [9],
        code: "YT",
        name_EN: "Mayotte",
        localPrefixes: [269, 639],
      },
      {
        prefix: "+52",
        size: [9, 10, 11],
        code: "MX",
        name_EN: "Mexico",
        localPrefixes: [
          1, 55, 744, 449, 833, 81, 624, 981, 998, 461, 983, 614, 747, 877,
          656, 871, 644, 834, 312, 963, 271, 777, 667, 646, 33, 473, 662, 715,
          612, 477, 314, 868, 999, 686, 443, 867, 951, 771, 984, 222, 322, 899,
          464, 844, 967, 444, 615, 442, 665, 311, 664, 246, 722, 961, 452, 985,
          457, 229, 618, 993, 228, 492, 351, 22, 44, 45, 56, 72, 77, 96, 99,
          200, 201, 231, 232, 233, 235, 236, 237, 238, 241, 243, 244, 245, 247,
          248, 249, 272, 273, 274, 275, 276, 278, 279, 281, 282, 283, 284, 285,
          287, 288, 294, 296, 297, 313, 315, 316, 317, 319, 321, 323, 324, 325,
          326, 327, 328, 329, 341, 342, 343, 344, 345, 346, 347, 348, 349, 352,
          353, 354, 355, 356, 357, 358, 359, 371, 372, 373, 374, 375, 376, 377,
          378, 381, 382, 383, 384, 385, 386, 387, 388, 389, 391, 392, 393, 394,
          395, 411, 412, 413, 414, 415, 417, 418, 419, 421, 422, 423, 424, 425,
          426, 427, 428, 429, 431, 432, 433, 434, 435, 436, 437, 438, 462, 463,
          465, 466, 467, 468, 469, 471, 472, 474, 475, 476, 478, 479, 481, 482,
          483, 485, 486, 487, 488, 489, 493, 494, 496, 498, 499, 588, 591, 592,
          593, 594, 595, 596, 597, 599, 613, 616, 621, 622, 623, 625, 626, 627,
          628, 629, 631, 632, 633, 634, 635, 636, 637, 638, 639, 641, 642, 643,
          645, 647, 648, 649, 651, 652, 653, 657, 658, 659, 660, 661, 663, 668,
          669, 671, 672, 673, 674, 675, 676, 677, 687, 694, 695, 696, 697, 698,
          711, 712, 713, 714, 716, 717, 718, 719, 731, 732, 733, 734, 735, 736,
          737, 738, 739, 741, 742, 743, 745, 746, 748, 749, 751, 753, 754, 755,
          756, 757, 758, 759, 761, 762, 763, 764, 765, 766, 767, 768, 769, 781,
          782, 783, 784, 785, 786, 789, 791, 797, 821, 823, 824, 825, 826, 828,
          829, 831, 832, 835, 836, 841, 842, 845, 846, 861, 862, 864, 866, 869,
          870, 872, 873, 878, 891, 892, 894, 897, 913, 914, 916, 917, 918, 919,
          921, 922, 923, 924, 932, 933, 934, 936, 937, 938, 953, 954, 958, 971,
          972, 982, 983, 986, 987, 988,
        ],
        default: true,
      },
      {
        prefix: "+691",
        size: [7],
        code: "FM",
        name_EN: "Micronesia",
        localPrefixes: [9, 32, 92, 33, 93, 94, 35, 95, 96, 37, 97],
        default: true,
      },
      {
        prefix: "+373",
        size: [7, 8, 9],
        code: "MD",
        name_EN: "Moldova",
        localPrefixes: [
          6, 7, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 37,
          39, 552, 555, 557,
        ],
        default: true,
      },
      {
        prefix: "+377",
        size: [8, 9],
        code: "MC",
        name_EN: "Monaco",
        localPrefixes: [9, 4, 6, 3, 7, 800, 870],
        default: true,
      },
      {
        prefix: "+976",
        size: [5, 7, 8, 9, 10],
        code: "MN",
        name_EN: "Mongolia",
        name_own: "Монгол",
        localPrefixes: [5, 8, 9, 1, 2, 6, 7, 48, 58, 37, 35, 43, 38],
        default: true,
      },
      {
        prefix: "+382",
        size: [8],
        code: "ME",
        name_EN: "Montenegro",
        name_own: "Монтенегро",
        localPrefixes: [6, 20, 30, 51, 50, 33, 41, 32, 31, 40, 52, 32],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "MS",
        name_EN: "Montserrat",
        localPrefixes: [664],
      },
      {
        prefix: "+212",
        size: [9],
        code: "MA",
        name_EN: "Morocco",
        name_own: "المغرب",
        localPrefixes: [6, 53, 52, 51, 54, 55, 7],
        default: true,
      },
      {
        prefix: "+258",
        size: [8, 9],
        code: "MZ",
        name_EN: "Mozambique",
        name_own: "Moçambique",
        localPrefixes: [
          8, 21, 23, 281, 293, 271, 251, 26, 272, 24, 252, 282, 250,
        ],
        default: true,
      },
      {
        prefix: "+95",
        size: [6, 7, 8, 9, 10],
        code: "MM",
        name_EN: "Myanmar",
        name_own: "မြန်မာ",
        localPrefixes: [9, 67, 52, 59, 2, 57, 64, 71, 42, 53, 43, 1, 8],
        default: true,
      },
      {
        prefix: "+264",
        size: [6, 7, 8, 9, 10],
        code: "NA",
        name_EN: "Namibia",
        localPrefixes: [8, 61, 67, 66, 63, 62, 65, 64, 60],
        default: true,
      },
      {
        prefix: "+674",
        size: [7],
        code: "NR",
        name_EN: "Nauru",
        localPrefixes: [444, 55, 222, 666, 777, 8, 999],
        default: true,
      },
      {
        prefix: "+977",
        size: [7, 8, 9, 10],
        code: "NP",
        name_EN: "Nepal",
        name_own: "नेपाल",
        localPrefixes: [
          98, 1, 56, 21, 51, 71, 91, 25, 41, 61, 23, 24, 26, 27, 29, 31, 33,
          35, 36, 37, 38, 44, 46, 47, 48, 49, 53, 55, 57, 63, 64, 65, 66, 67,
          68, 69, 75, 76, 77, 78, 79, 81, 82, 83, 84, 86, 87, 88, 89, 92, 93,
          94, 95, 96, 97,
        ],
        default: true,
      },
      {
        prefix: "+31",
        size: [9],
        code: "NL",
        name_EN: "Netherlands",
        name_own: "Nederland",
        localPrefixes: [
          6, 20, 72, 36, 172, 33, 55, 26, 73, 76, 15, 570, 78, 318,
          40, 591, 53, 50, 23, 45, 492, 35, 58, 71, 43, 174, 24, 10,
          46, 70, 13, 30, 77, 75, 79, 38, 74, 111, 113, 114, 115, 117,
          118, 161, 162, 164, 165, 166, 167, 168, 180, 181, 182, 183, 184, 186,
          187, 222, 223, 224, 226, 227, 228, 229, 251, 252, 255, 294, 297, 299,
          313, 314, 315, 316, 317, 320, 321, 341, 342, 343, 344, 345, 346, 347,
          348, 411, 412, 413, 416, 418, 475, 478, 481, 485, 486, 487, 488, 493,
          495, 497, 499, 511, 512, 513, 514, 515, 516, 517, 518, 519, 592, 593,
          594, 595, 596, 597, 598, 599, 521, 522, 523, 524, 525, 527, 528, 529,
          541, 543, 544, 545, 546, 547, 548, 561, 562, 566, 571, 572, 573, 575,
          577, 578,
        ],
        default: true,
      },
      {
        prefix: "+599",
        size: [7, 8],
        code: "AN",
        name_EN: "Netherlands Antilles",
        name_own: "Nederlandse Antillen",
        localPrefixes: [9, 7, 4, 3, 5],
      },
      {
        prefix: "+687",
        size: [6],
        code: "NC",
        name_EN: "New Caledonia",
        name_own: "Nouvelle Calédonie",
        localPrefixes: [7, 8, 9, 2, 3, 4, 5],
        default: true,
      },
      {
        prefix: "+64",
        size: [8, 10],
        code: "NZ",
        name_EN: "New Zealand",
        name_own: "I Niu Tireni",
        localPrefixes: [2, 4, 9, 3, 7, 6, 2409],
        default: true,
      },
      {
        prefix: "+505",
        size: [8],
        code: "NI",
        name_EN: "Nicaragua",
        localPrefixes: [8, 22, 24, 25, 23, 27, 20, 21, 26, 28, 29, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+227",
        size: [8],
        code: "NE",
        name_EN: "Niger",
        localPrefixes: [20, 9, 21, 23, 70, 74, 76, 77, 8],
        default: true,
      },
      {
        prefix: "+234",
        size: [6, 7, 8, 9, 10],
        code: "NG",
        name_EN: "Nigeria",
        localPrefixes: [
          70, 80, 81, 9, 43, 30, 34, 56, 48, 77, 52, 68, 87, 74, 64, 42, 72,
          63, 2, 1, 31, 79, 73, 62, 65, 47, 58, 76, 44, 66, 35, 83, 84, 60, 88,
          85, 89, 75, 69, 71,
        ],
        default: true,
      },
      {
        prefix: "+683",
        size: [4],
        code: "NU",
        name_EN: "Niue",
        localPrefixes: [3, 4, 1, 2, 5, 6, 7],
        default: true,
      },
      {
        prefix: "+850",
        size: [8, 9, 10],
        code: "KP",
        name_EN: "North Korea",
        name_own: "북한",
        localPrefixes: [
          191, 2, 73, 53, 49, 41, 61, 57, 192, 193, 31, 39, 45, 67, 79, 85,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "MP",
        name_EN: "Northern Mariana Islands",
        localPrefixes: [670],
      },
      {
        prefix: "+47",
        size: [7, 8, 9],
        code: "NO",
        name_EN: "Norway",
        name_own: "Norge",
        localPrefixes: [
          4, 9, 2, 7, 37, 5, 3, 35, 69, 62, 32, 38, 33, 79, 77, 6,
        ],
        default: true,
      },
      {
        prefix: "+968",
        size: [6, 8],
        code: "OM",
        name_EN: "Oman",
        name_own: "سلطنة عمان",
        localPrefixes: [9, 24, 25, 23, 26, 21, 22, 7],
        default: true,
      },
      {
        prefix: "+92",
        size: [8, 9, 10],
        code: "PK",
        name_EN: "Pakistan",
        name_own: "پاکستان",
        localPrefixes: [
          3, 21, 22, 25, 40, 41, 42, 44, 46, 47, 48, 49, 51, 52, 53, 55, 56,
          57, 61, 62, 63, 64, 65, 66, 67, 68, 71, 74, 81, 86, 91, 232, 233,
          235, 238, 242, 243, 244, 292, 293, 294, 295, 296, 297, 298, 453,
          454, 457, 459, 542, 544, 546, 547, 604, 606, 608, 722, 723, 726,
          822, 823, 826, 828, 829, 832, 833, 835, 837, 838, 843, 844, 847,
          848, 852, 853, 855, 856, 922, 923, 924, 925, 926, 927, 928, 932,
          937, 938, 939, 942, 943, 944, 945, 946, 963, 965, 966, 969, 992,
          995, 996, 997, 998,
        ],
        default: true,
      },
      {
        prefix: "+680",
        size: [7],
        code: "PW",
        name_EN: "Palau",
        localPrefixes: [
          77, 62, 63, 64, 66, 68, 69, 654, 488, 45, 88, 255, 277, 345, 460,
          461, 462, 463, 464, 465, 535, 544, 587, 620, 630, 640, 660, 680,
          690, 733, 747, 780, 824, 830, 831, 832, 833, 834, 835, 855, 876,
          900,
        ],
        default: true,
      },
      {
        prefix: "+970",
        size: [8, 9],
        code: "PS",
        name_EN: "Palestine",
        name_own: "فلسطين",
        localPrefixes: [5, 8, 2, 4, 9],
        default: true,
      },
      {
        prefix: "+507",
        size: [7, 8],
        code: "PA",
        name_EN: "Panama",
        localPrefixes: [6, 2, 3, 5, 7, 9, 4, 1, 8],
        default: true,
      },
      {
        prefix: "+675",
        size: [7, 8],
        code: "PG",
        name_EN: "Papua New Guinea",
        localPrefixes: [7, 3, 97, 53, 98, 85, 54, 42, 45, 47, 64, 81, 82, 83, 84, 88],
        default: true,
      },
      {
        prefix: "+595",
        size: [8, 9, 10],
        code: "PY",
        name_EN: "Paraguay",
        localPrefixes: [
          9, 21, 24, 25, 26, 28, 224, 226, 227, 228, 271, 275, 291, 292, 293,
          294, 295, 318, 32, 331, 336, 337, 342, 343, 345, 347, 351, 36, 37,
          38, 39, 41, 42, 431, 432, 44, 451, 453, 46, 47, 48, 491, 492, 493,
          494, 497, 51, 52, 53, 54, 550, 552, 553, 554, 61, 631, 632, 633,
          644, 671, 672, 673, 674, 675, 676, 677, 678, 71, 72, 73, 740, 741,
          742, 743, 744, 75, 761, 762, 763, 765, 767, 768, 775, 780, 781,
          782, 783, 784, 785, 786, 787, 788, 81, 82, 83, 858, 86, 20, 30, 40,
          50, 60, 70, 80, 90,
        ],
        default: true,
      },
      {
        prefix: "+51",
        size: [7, 8, 9],
        code: "PE",
        name_EN: "Peru",
        localPrefixes: [
          9, 1, 83, 54, 51, 66, 76, 14, 63, 41, 74, 43, 56, 84, 67, 64, 62,
          65, 53, 42, 73, 61, 82, 52, 44, 72, 81, 86, 87, 755, 687,
        ],
        default: true,
      },
      {
        prefix: "+63",
        size: [8, 9, 10],
        code: "PH",
        name_EN: "Philippines",
        localPrefixes: [
          9, 2, 45, 34, 46, 74, 44, 43, 49, 85, 88, 55, 32, 64, 75, 82, 35,
          83, 33, 52, 42, 54, 47, 48, 36, 93, 53, 84, 62, 38, 56, 63, 65, 68,
          72, 77, 78, 86, 87, 81, 89, 1,
        ],
        default: true,
      },
      {
        prefix: "+48",
        size: [9],
        code: "PL",
        name_EN: "Poland",
        name_own: "Polska",
        localPrefixes: [
          12, 13, 14, 15, 16, 17, 18, 22, 23, 24, 25, 26, 29, 32, 33, 34, 41,
          42, 43, 44, 45, 46, 48, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
          61, 62, 63, 65, 66, 67, 68, 69, 71, 72, 73, 74, 75, 76, 77, 78, 79,
          81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 94, 95,
        ],
        default: true,
      },
      {
        prefix: "+351",
        size: [8, 9, 10],
        code: "PT",
        name_EN: "Portugal",
        localPrefixes: [
          8, 9, 21, 241, 295, 235, 234, 284, 253, 273, 262, 272, 286, 276,
          239, 275, 268, 266, 289, 233, 291, 271, 292, 277, 282, 244, 22,
          231, 278, 285, 283, 255, 254, 236, 296, 242, 245, 274, 243, 269,
          256, 238, 265, 219, 281, 279, 249, 261, 251, 258, 263, 252, 259,
          232, 257, 30, 70,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [7, 10],
        code: "PR",
        name_EN: "Puerto Rico",
        localPrefixes: [787, 939],
      },
      {
        prefix: "+974",
        size: [8],
        code: "QA",
        name_EN: "Qatar",
        name_own: "دولة قطر",
        localPrefixes: [3, 4, 5, 6, 7, 21, 23, 26],
        default: true,
      },
      {
        prefix: "+242",
        size: [7, 9],
        code: "CG",
        name_EN: "Republic of the Congo",
        name_own: "République du Congo",
        localPrefixes: [8, 9, 1, 3, 6, 5, 4, 2, 0],
        default: true,
      },
      {
        prefix: "+262",
        size: [9],
        code: "RE",
        name_EN: "Reunion",
        name_own: "Réunion",
        localPrefixes: [692, 693, 262, 263],
        default: true,
      },
      {
        prefix: "+40",
        size: [8, 9, 10],
        code: "RO",
        name_EN: "Romania",
        name_own: "România",
        localPrefixes: [
          7, 21, 258, 241, 269, 259, 247, 243, 257, 244, 240, 250, 255, 249,
          263, 233, 246, 234, 256, 254, 260, 264, 248, 267, 251, 231, 268,
          230, 239, 245, 237, 236, 266, 238, 235, 232, 265, 262, 221, 261,
          253, 242, 252, 2179, 31, 33, 34, 35, 36, 6,
        ],
        default: true,
      },
      {
        prefix: "+7",
        size: [8, 9, 10, 11, 12],
        code: "RU",
        name_EN: "Russia",
        name_own: "Россия",
        localPrefixes: [
          9, 495, 499, 8182, 8512, 3852, 4722, 4832, 8352, 3512, 8202, 3022,
          343, 3952, 4932, 3412, 4212, 4012, 4842, 843, 3842, 83361, 861,
          3912, 3522, 47122, 4742, 3519, 8722, 8152, 8552, 8312, 3435, 3843,
          383, 3812, 3532, 4862, 8412, 342, 4912, 48536, 863, 846, 812, 8452,
          4812, 8622, 8652, 3462, 3452, 8482, 3822, 4872, 4822, 3472, 3012,
          8422, 8672, 4922, 4232, 8442, 8443, 4732, 4112, 4852, 336, 349, 365,
          381, 388, 390, 394, 413, 415, 416, 424, 426, 427, 475, 496, 498,
          811, 813, 814, 816, 817, 821, 834, 836, 840, 847, 856, 857, 860,
          868, 869, 871, 873, 877, 878, 879,
        ],
        default: true,
      },
      {
        prefix: "+250",
        size: [9],
        code: "RW",
        name_EN: "Rwanda",
        localPrefixes: [25, 7, 22, 23, 26, 28],
        default: true,
      },
      {
        prefix: "+590",
        size: [9],
        code: "BL",
        name_EN: "Saint Barthelemy",
        localPrefixes: [690, 590, 691],
      },
      {
        prefix: "+290",
        size: [5],
        code: "SH",
        name_EN: "Saint Helena",
        localPrefixes: [5, 6, 2, 8],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "KN",
        name_EN: "Saint Kitts and Nevis",
        localPrefixes: [869],
      },
      {
        prefix: "+1",
        size: [10],
        code: "LC",
        name_EN: "Saint Lucia",
        localPrefixes: [758],
      },
      {
        prefix: "+590",
        size: [9],
        code: "MF",
        name_EN: "Saint Martin",
        localPrefixes: [690, 590, 691],
        default: true,
      },
      {
        prefix: "+508",
        size: [6],
        code: "PM",
        name_EN: "Saint Pierre and Miquelon",
        name_own: "Saint-Pierre-et-Miquelon",
        localPrefixes: [2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "VC",
        name_EN: "Saint Vincent and the Grenadines",
        localPrefixes: [784],
      },
      {
        prefix: "+685",
        size: [5, 7],
        code: "WS",
        name_EN: "Samoa",
        localPrefixes: [7, 2, 3, 6, 5, 4, 8],
        default: true,
      },
      {
        prefix: "+378",
        size: [10],
        code: "SM",
        name_EN: "San Marino",
        localPrefixes: ["3", "6", "0549", "5", "7"],
        default: true,
      },
      {
        prefix: "+239",
        size: [7],
        code: "ST",
        name_EN: "Sao Tome and Principe",
        name_own: "São Tomé e Príncipe",
        localPrefixes: [22, 98, 99, 90],
        default: true,
      },
      {
        prefix: "+966",
        size: [9],
        code: "SA",
        name_EN: "Saudí Arabia",
        name_own: "المملكة العربية السعودية",
        localPrefixes: [5, 11, 17, 14, 13, 16, 12, 9, 800],
        default: true,
      },
      {
        prefix: "+221",
        size: [9],
        code: "SN",
        name_EN: "Senegal",
        name_own: "Sénégal",
        localPrefixes: [33, 7, 8, 30],
        default: true,
      },
      {
        prefix: "+381",
        size: [7, 8, 9],
        code: "RS",
        name_EN: "Serbia",
        name_own: "Србија",
        localPrefixes: [
          6, 11, 32, 390, 35, 34, 36, 37, 16, 18, 20, 21, 13, 39, 38, 29, 51,
          15, 26, 25, 24, 290, 31, 17, 23, 10, 12, 14, 19, 22, 27, 28, 30, 33,
          7, 8, 90,
        ],
        default: true,
      },
      {
        prefix: "+248",
        size: [7],
        code: "SC",
        name_EN: "Seychelles",
        name_own: "les Seychelles",
        localPrefixes: [2, 4],
        default: true,
      },
      {
        prefix: "+232",
        size: [8],
        code: "SL",
        name_EN: "Sierra Leone",
        localPrefixes: [
          76, 77, 78, 79, 30, 33, 34, 88, 40, 44, 21, 25, 50, 55, 22, 32, 52,
          70, 71, 72, 73, 74, 75, 31, 35, 66, 80, 90, 99,
        ],
        default: true,
      },
      {
        prefix: "+65",
        size: [8],
        code: "SG",
        name_EN: "Singapore",
        name_own: "Singapura",
        localPrefixes: [3, 6, 8, 9],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "SX",
        name_EN: "Sint Maarten",
        name_own: "Sint-Maarten",
        localPrefixes: [721],
      },
      {
        prefix: "+421",
        size: [8, 9, 10],
        code: "SK",
        name_EN: "Slovakia",
        name_own: "Slovensko",
        localPrefixes: [
          9, 2, 48, 54, 31, 57, 55, 36, 44, 47, 43, 56, 37, 35, 52, 42, 51, 46,
          58, 2, 34, 53, 38, 32, 33, 41, 45,
        ],
        default: true,
      },
      {
        prefix: "+386",
        size: [8],
        code: "SI",
        name_EN: "Slovenia",
        name_own: "Slovenija",
        localPrefixes: [
          30, 31, 40, 41, 51, 64, 65, 66, 67, 68, 69, 70, 71, 1, 3, 5, 4, 7, 2,
        ],
        default: true,
      },
      {
        prefix: "+677",
        size: [5, 7],
        code: "SB",
        name_EN: "Solomon Islands",
        localPrefixes: [
          7, 8, 2, 1, 40, 35, 60, 50, 53, 63, 32, 3, 41, 42, 48, 61, 62, 67,
          9, 51, 52,
        ],
        default: true,
      },
      {
        prefix: "+252",
        size: [7, 8],
        code: "SO",
        name_EN: "Somalia",
        name_own: "Soomaaliya",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+27",
        size: [9],
        code: "ZA",
        name_EN: "South Africa",
        name_own: "Suid-Afrika",
        localPrefixes: [
          7, 8, 51, 21, 12, 11, 18, 31, 44, 53, 43, 13, 34, 33, 15, 41, 14,
          16, 57, 10, 17, 22, 23, 27, 28, 32, 35, 36, 39, 54, 56, 58, 40, 42,
          45, 46, 47, 48, 49, 6,
        ],
        default: true,
      },
      {
        prefix: "+82",
        size: [7, 8, 9, 10],
        code: "KR",
        name_EN: "South Korea",
        name_own: "대한민국",
        localPrefixes: [
          1, 2, 31, 32, 33, 41, 42, 43, 44, 51, 52, 53, 54, 55, 61, 62, 63, 64,
        ],
        default: true,
      },
      {
        prefix: "+211",
        size: [9],
        code: "SS",
        name_EN: "South Sudan",
        localPrefixes: [1, 9],
        default: true,
      },
      {
        prefix: "+34",
        size: [9],
        code: "ES",
        name_EN: "Spain",
        name_own: "España",
        localPrefixes: [
          6, 7, 8, 91, 967, 867, 96, 865, 950, 850, 920, 924, 824, 93, 94, 900,
          901, 902, 947, 927, 827, 956, 856, 964, 864, 956, 926, 826, 957, 857,
          969, 972, 872, 98, 958, 858, 949, 959, 859, 974, 874, 971, 871, 953,
          853, 981, 881, 928, 828, 987, 887, 973, 873, 941, 982, 95, 851, 924,
          968, 868, 988, 98, 979, 971, 871, 948, 848, 986, 886, 923, 943, 843,
          942, 842, 921, 95, 854, 975, 875, 922, 822, 977, 877, 978, 925, 825,
          96, 983, 883, 986, 945, 980, 976, 876,
        ],
        default: true,
      },
      {
        prefix: "+94",
        size: [9],
        code: "LK",
        name_EN: "Sri Lanka",
        name_own: "ශ්රී ලංකාව",
        localPrefixes: [
          7, 11, 25, 55, 65, 66, 91, 21, 67, 81, 24, 37, 31, 45, 26, 23, 27,
          32, 33, 34, 35, 36, 38, 41, 47, 51, 52, 54, 57, 63, 82,
        ],
        default: true,
      },
      {
        prefix: "+249",
        size: [9],
        code: "SD",
        name_EN: "Sudan",
        name_own: "السودان",
        localPrefixes: [1, 9],
        default: true,
      },
      {
        prefix: "+597",
        size: [6, 7],
        code: "SR",
        name_EN: "Suriname",
        localPrefixes: [6, 7, 8, 9, 4, 5, 3, 2],
        default: true,
      },
      {
        prefix: "+268",
        size: [8],
        code: "SZ",
        name_EN: "Swaziland",
        localPrefixes: [7, 24, 25, 22, 23, 32, 33, 34, 35],
        default: true,
      },
      {
        prefix: "+46",
        size: [6, 7, 8, 9, 10, 11],
        code: "SE",
        name_EN: "Sweden",
        name_own: "Sverige",
        localPrefixes: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        default: true,
      },
      {
        prefix: "+41",
        size: [9],
        code: "CH",
        name_EN: "Switzerland",
        name_own: "Schweiz",
        localPrefixes: [
          7, 31, 24, 56, 61, 91, 32, 34, 81, 26, 22, 43, 44, 34, 21, 62, 55,
          71, 27, 33, 52, 24, 41, 68, 69,
        ],
        default: true,
      },
      {
        prefix: "+963",
        size: [8, 9],
        code: "SY",
        name_EN: "Syria",
        name_own: "سوريا",
        localPrefixes: [
          9, 11, 52, 12, 21, 16, 15, 51, 33, 31, 23, 41, 25, 34, 53, 14, 22,
          43, 13, 44, 50,
        ],
        default: true,
      },
      {
        prefix: "+886",
        size: [8, 9, 10],
        code: "TW",
        name_EN: "Taiwan",
        name_own: "台灣",
        localPrefixes: [9, 2, 3, 5, 4, 7, 82, 836, 37, 49, 6, 8, 89, 826],
        default: true,
      },
      {
        prefix: "+992",
        size: [8, 9, 10],
        code: "TJ",
        name_EN: "Tajikistan",
        name_own: "Точикистон",
        localPrefixes: [
          9, 372, 313, 314, 315, 322, 324, 325, 331, 332, 342, 344, 345, 346,
          347, 352, 355, 446, 474, 487,
        ],
        default: true,
      },
      {
        prefix: "+255",
        size: [9],
        code: "TZ",
        name_EN: "Tanzania",
        localPrefixes: [7, 26, 27, 22, 28, 23, 25, 24, 6],
        default: true,
      },
      {
        prefix: "+66",
        size: [8, 9, 10],
        code: "TH",
        name_EN: "Thailand",
        name_own: "ประเทศไทย",
        localPrefixes: [
          8, 2, 53, 38, 74, 43, 54, 34, 44, 75, 55, 76, 77, 45, 42, 32, 33,
          35, 36, 37, 39, 52, 56, 73, 6, 9,
        ],
        default: true,
      },
      {
        prefix: "+228",
        size: [8],
        code: "TG",
        name_EN: "Togo",
        name_own: "Aller",
        localPrefixes: [9, 22, 24, 25, 26, 23, 27, 7],
        default: true,
      },
      {
        prefix: "+690",
        size: [4],
        code: "TK",
        name_EN: "Tokelau",
        localPrefixes: [2, 3, 4, 7],
        default: true,
      },
      {
        prefix: "+676",
        size: [5],
        code: "TO",
        name_EN: "Tonga",
        localPrefixes: [
          15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
          32, 33, 34, 35, 36, 37, 38, 40, 41, 42, 43, 44, 46, 49, 50, 53, 54,
          55, 56, 57, 58, 59, 60, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73,
          74, 75, 76, 77, 78, 79, 80, 84, 85, 86, 87, 88, 89,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "TT",
        name_EN: "Trinidad and Tobago",
        localPrefixes: [868],
      },
      {
        prefix: "+216",
        size: [8],
        code: "TN",
        name_EN: "Tunisia",
        name_own: "تونس",
        localPrefixes: [
          2, 4, 9, 80, 82, 88, 71, 72, 75, 76, 77, 73, 74, 3, 70, 78, 79,
        ],
        default: true,
      },
      {
        prefix: "+90",
        size: [10],
        code: "TR",
        name_EN: "Turkey",
        name_own: "Türkiye",
        localPrefixes: [
          5, 312, 322, 264, 416, 272, 472, 382, 358, 326, 242, 478, 256,
          266, 378, 488, 458, 228, 426, 434, 374, 248, 224, 286, 376, 364,
          258, 412, 380, 284, 424, 446, 442, 222, 232, 212, 216, 342, 454,
          406, 438, 476, 246, 262, 344, 370, 338, 474, 366, 352, 348, 312,
          288, 386, 332, 274, 422, 236, 482, 324, 252, 436, 384, 388, 452,
          328, 464, 362, 414, 484, 368, 486, 346, 282, 356, 462, 428, 276,
          432, 226, 354, 372, 238, 318, 392, 456, 466,
        ],
        default: true,
      },
      {
        prefix: "+993",
        size: [7, 8, 9],
        code: "TM",
        name_EN: "Turkmenistan",
        name_own: "Türkmenistan",
        localPrefixes: [
          12, 13, 222, 240, 241, 242, 243, 245, 246, 247, 248, 322, 340,
          343, 344, 345, 346, 347, 348, 349, 422, 431, 432, 438, 44, 461,
          465, 522, 557, 558, 559, 560, 561, 564, 565, 566, 568, 569, 6,
          71, 72,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "TC",
        name_EN: "Turks and Caicos Islands",
        localPrefixes: [649],
      },
      {
        prefix: "+688",
        size: [5, 6],
        code: "TV",
        name_EN: "Tuvalu",
        localPrefixes: [20, 90, 70, 71],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "VI",
        name_EN: "U.S. Virgin Islands",
        localPrefixes: [340],
      },
      {
        prefix: "+256",
        size: [8, 9, 10],
        code: "UG",
        name_EN: "Uganda",
        localPrefixes: [
          7, 41, 476, 41, 483, 471, 43, 486, 473, 481, 465, 45, 485, 46, 3,
          464, 2, 4,
        ],
        default: true,
      },
      {
        prefix: "+380",
        size: [9],
        code: "UA",
        name_EN: "Ukraine",
        name_own: "Україна",
        localPrefixes: [
          39, 50, 63, 66, 67, 68, 9, 44, 6442, 6153, 4563, 47, 46, 37, 56,
          569, 62, 624, 34, 55, 38, 6561, 57, 52, 5447, 626, 536, 56, 32, 64,
          33, 6451, 623, 619, 629, 51, 566, 48, 53, 45, 36, 69, 6452, 65,
          626, 54, 35, 31, 43, 61, 41, 71, 72, 73, 75, 77,
        ],
        default: true,
      },
      {
        prefix: "+971",
        size: [8, 9],
        code: "AE",
        name_EN: "United Arab Emirates",
        name_own: "الإمارات العربية المتحدة",
        localPrefixes: [5, 2, 6, 3, 4, 9, 6, 7],
        default: true,
      },
      {
        prefix: "+44",
        size: [6, 7, 8, 9, 10, 11, 12, 13],
        code: "GB",
        name_EN: "United Kingdom",
        localPrefixes: [
          7, 1, 20, 23, 24, 28, 29, 30, 33, 34, 37, 56, 80, 84, 87, 90, 91,
          98,
        ],
        default: true,
      },
      {
        prefix: "+1",
        size: [10],
        code: "US",
        name_EN: "United States",
        name_own: "United States",
        localPrefixes: [
          201, 202, 203, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215,
          216, 217, 218, 219, 220, 223, 224, 225, 227, 228, 229, 231, 234,
          235, 239, 240, 248, 251, 252, 253, 254, 256, 260, 262, 267, 269,
          270, 272, 274, 276, 279, 281, 283, 301, 302, 303, 304, 305, 307,
          308, 309, 310, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321,
          323, 324, 325, 326, 327, 329, 330, 331, 332, 334, 336, 337, 339,
          341, 346, 347, 350, 351, 352, 353, 357, 360, 361, 363, 364, 369,
          380, 385, 386, 401, 402, 404, 405, 406, 407, 408, 409, 410, 412,
          413, 414, 415, 417, 419, 423, 424, 425, 430, 432, 434, 435, 436,
          440, 442, 443, 445, 447, 448, 457, 458, 463, 464, 465, 469, 470,
          471, 472, 475, 478, 479, 480, 484, 501, 502, 503, 504, 505, 507,
          508, 509, 510, 512, 513, 515, 516, 517, 518, 520, 530, 531, 534,
          539, 540, 541, 551, 557, 559, 561, 562, 563, 564, 567, 570, 571,
          572, 573, 574, 575, 580, 582, 585, 586, 601, 602, 603, 605, 606,
          607, 608, 609, 610, 612, 614, 615, 616, 617, 618, 619, 620, 621,
          623, 624, 626, 628, 629, 630, 631, 636, 640, 641, 645, 646, 650,
          651, 656, 657, 659, 660, 661, 662, 667, 669, 678, 679, 680, 681,
          682, 686, 689, 701, 702, 703, 704, 706, 707, 708, 712, 713, 714,
          715, 716, 717, 718, 719, 720, 724, 725, 726, 727, 728, 729, 730,
          731, 732, 734, 737, 738, 740, 743, 747, 748, 754, 757, 760, 762,
          763, 765, 769, 770, 771, 772, 773, 774, 775, 779, 781, 785, 786,
          801, 802, 803, 804, 805, 806, 808, 810, 812, 813, 814, 815, 816,
          817, 818, 820, 821, 826, 828, 830, 831, 832, 835, 837, 838, 839,
          840, 843, 845, 847, 848, 850, 854, 856, 857, 858, 859, 860, 861,
          862, 863, 864, 865, 870, 872, 878, 901, 903, 904, 906, 907, 908,
          909, 910, 912, 913, 914, 915, 916, 917, 918, 919, 920, 924, 925,
          928, 929, 930, 931, 934, 936, 937, 938, 940, 941, 943, 945, 947,
          948, 949, 951, 952, 954, 956, 959, 970, 971, 972, 973, 975, 978,
          979, 980, 983, 984, 985, 986, 989,
        ],
        default: true,
      },
      {
        prefix: "+598",
        size: [8],
        code: "UY",
        name_EN: "Uruguay",
        localPrefixes: [
          9, 2, 4, 2, 477, 433, 452, 42, 436, 435, 456, 433, 464, 453, 444,
          472, 462, 447, 473, 434, 42, 463, 445, 436, 1770, 1920, 1987, 1997,
        ],
        default: true,
      },
      {
        prefix: "+998",
        size: [9],
        code: "UZ",
        name_EN: "Uzbekistan",
        name_own: "O'zbekiston",
        localPrefixes: [
          9, 71, 74, 65, 62, 72, 73, 61, 75, 69, 79, 66, 67, 76, 55, 78,
        ],
        default: true,
      },
      {
        prefix: "+678",
        size: [5, 7],
        code: "VU",
        name_EN: "Vanuatu",
        localPrefixes: [5, 7, 2, 37, 36, 34, 35, 38, 48, 8],
        default: true,
      },
      {
        prefix: "+379",
        size: [7, 8, 9, 10, 11, 12],
        code: "VA",
        name_EN: "Vatican",
        name_own: "Vaticano",
        localPrefixes: ["06698", 3],
        default: true,
      },
      {
        prefix: "+58",
        size: [10],
        code: "VE",
        name_EN: "Venezuela",
        localPrefixes: [2, 4],
        default: true,
      },
      {
        prefix: "+84",
        size: [8, 9, 10, 11],
        code: "VN",
        name_EN: "Vietnam",
        name_own: "Việt Nam",
        localPrefixes: [
          9, 1, 4, 781, 61, 500, 780, 710, 63, 511, 33, 320, 31, 8, 54, 76,
          77, 350, 58, 62, 56, 77, 280, 37, 38, 64, 2, 3, 5, 7,
        ],
        default: true,
      },
      {
        prefix: "+681",
        size: [6],
        code: "WF",
        name_EN: "Wallis and Futuna",
        name_own: "Wallis et Futuna",
        localPrefixes: [50, 68, 72, 82, 83],
        default: true,
      },
      {
        prefix: "+212",
        size: [9],
        code: "EH",
        name_EN: "Western Sahara",
        name_own: "الصحراء الغربية",
        localPrefixes: [6, 7, 528],
      },
      {
        prefix: "+967",
        size: [7, 8, 9],
        code: "YE",
        name_EN: "Yemen",
        name_own: "اليمن",
        localPrefixes: [7, 1, 2, 6, 3, 7, 5, 4],
        default: true,
      },
      {
        prefix: "+260",
        size: [9],
        code: "ZM",
        name_EN: "Zambia",
        localPrefixes: [21, 9, 211, 212, 216, 215, 214, 213, 5, 7],
        default: true,
      },
      {
        prefix: "+263",
        size: [4, 5, 6, 7, 8, 9, 10, 11, 12],
        code: "ZW",
        name_EN: "Zimbabwe",
        name_own: "",
        localPrefixes: [86, 71, 73, 77, 78, 9, 270, 4, 54, 20, 667, 1],
        default: true,
      },
    ];
  },
};
